export enum NotificationType {
  MESSAGE = "message",
  NORMAL = "normal",
  IMPORTANT = "important",
}

export type NotificationRead = { luLe: string; luPar: string | null };
